module.exports = __webpack_public_path__ + "static/media/youssef2.92262903.webp";